var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightArrowGrey(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17523_19560)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.48476 10.1439C5.48476 9.84559 5.72656 9.60379 6.02484 9.60379L13.6627 9.60379C13.9609 9.60379 14.2027 9.84559 14.2027 10.1439C14.2027 10.4421 13.9609 10.6839 13.6627 10.6839L6.02484 10.6839C5.72656 10.6839 5.48476 10.4421 5.48476 10.1439Z",
    fill: "#A9B5C1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.46186 14.3447C9.25095 14.1338 9.25095 13.7918 9.46186 13.5809L12.8989 10.1439L9.46186 6.70685C9.25095 6.49594 9.25095 6.15398 9.46186 5.94307C9.67277 5.73215 10.0147 5.73215 10.2256 5.94307L14.0446 9.76198C14.2555 9.97289 14.2555 10.3148 14.0446 10.5258L10.2256 14.3447C10.0147 14.5556 9.67277 14.5556 9.46186 14.3447Z",
    fill: "#A9B5C1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17523_19560"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.9618,
    height: 12.9618,
    fill: "white",
    transform: "translate(9.84375 19.3125) rotate(-135)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrowGrey);
export default __webpack_public_path__ + "static/media/RightArrowGrey.61d30761c79420299281d0872a33ae12.svg";
export { ForwardRef as ReactComponent };